import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    list: {
      overflowY: 'auto',
      overflowX: 'hidden',
      marginTop: theme.spacing(-1),
    },
    errorMessage: {
      padding: theme.spacing(0, 2),
    },
    ul: {
      padding: 0,
      margin: theme.spacing(0, 1),
    },
  };
};
